import { Controller } from "react-hook-form";
import { Input, InputProps } from "@heroui/react";
import { useRef } from "react";

function NumberInputComponent({
    name,
    onAutosave,
    hideErrorMessage,
    ...props
}: {
    name: string;
    hideErrorMessage?: boolean;
    onAutosave?: () => void;
} & InputProps) {
    const inputRef = useRef<number | null>(null);
    return (
        <Controller
            name={name}
            render={({
                fieldState: { error, invalid },
                field: { onBlur, onChange, value },
            }) => {
                const handleFocus = () => {
                    inputRef.current = value !== "" ? Number(value) : null;
                };
                const handleBlur = () => {
                    onBlur();
                    const currentValue = value !== "" ? Number(value) : null;
                    if (inputRef.current !== currentValue && onAutosave) {
                        onAutosave();
                    }
                };
                const handleKeyDown = (event: React.KeyboardEvent) => {
                    if (event.key === "Enter") {
                        event.preventDefault();
                        const currentValue =
                            value !== "" ? Number(value) : null;
                        if (inputRef.current !== currentValue && onAutosave) {
                            onAutosave();
                        }
                    }
                };
                return (
                    <div className="grid w-full grid-cols-1">
                        <Input
                            {...props}
                            isInvalid={invalid}
                            errorMessage={
                                hideErrorMessage ? undefined : error?.message
                            }
                            onBlur={handleBlur}
                            onChange={onChange}
                            onFocus={handleFocus}
                            onKeyDown={handleKeyDown}
                            type="number"
                            value={value ?? ""}
                        />
                    </div>
                );
            }}
        />
    );
}

export default NumberInputComponent;
